import { render, staticRenderFns } from "./system.vue?vue&type=template&id=d770abfa&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"
import style0 from "./system.vue?vue&type=style&index=0&id=d770abfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d770abfa",
  null
  
)

export default component.exports